<script>

export default {
  props: {
    user: Object,
    thisUser: Object,
    enabledSmartHR: {
      type: Boolean,
      default: false,
    },
    hasSmartHRAttendenceToken: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      email: "",
      formData: {
        name: "",
        furigana: "",
        phone: "",
        SMSVerified: "",
        preferredBranch: ""
      }
    }
  },
  methods: {
    setFormData() {
      this.formData.name = this.user.Name;
      this.formData.furigana = this.user.Furigana;
      this.formData.phone = this.user.Phone || this.thisUser.phone || '';
      this.formData.employeeID = this.user.ID;
      this.formData.SMSVerified = this.thisUser.phone ? 1 : 0;
    },
    async handleSubmit() {
      if (this.isLoading) {
        return;
      }
      if (!validate()) {
        return;
      }
      this.isLoading = true;
      $.post(this.thisUser.url, this.formData)
        .done(() =>  {
          window.location.reload()
        })
        .fail((response) => {
          console.error(response)
          this.isLoading = false;
        });
    },
    setInitialPreferredBranch() {
      const preferredBranch = this.thisUser.employsCompanies.find(branch => branch.isPreferred);
      this.formData.preferredBranch = preferredBranch ? preferredBranch.id : "none";
    },
    getCompanyNames(comIDList) {
      return comIDList.map((comID) => {
        return this.thisUser.comMap[comID]?.Name || '';
      }).join(', ');
    },
    handleOpenPasswordModal() {
      this.$emit('open-password-modal');
    },
    handleOpenEmailModal() {
      this.$emit('open-email-modal');
    },
    openSmartHRAttendanceTokenModal() {
      this.$emit('open-smartHR-attendance-token-modal');
    },
  },
  computed: {
    loadingClass() {
      return this.isLoading ? "loading" : "";
    },
    isReadonly() {
      return this.thisUser.phone || this.user.SMSVerified;
    },
    hasMultipleIDs() {
      return Object.keys(this.thisUser.employeeIDMap).length > 1;
    },
    isEmailEmpty() {
      return this.user.Email === '-';
    }
  },
  mounted() {
    this.setFormData();
    this.setInitialPreferredBranch();
  },
}
</script>

<template>
  <div class="user-form-container">
    <div class="user-details">

      <div class="form-padding">
        <div v-for="(comIDList, employeeID) in thisUser.employeeIDMap" class="form-group user-new-form-group">
          <label for="employee-id">社員番号
            <span v-if="hasMultipleIDs" class="text-gray">
              ({{ getCompanyNames(comIDList) }})
            </span>
          </label>
          <div class="col-12">
            <input class="form-input user-new-form-id br-5" name="employeeID" :value="employeeID" readonly>
          </div>
        </div>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="form-padding">
          <label for="name">
            名前
            <input v-model="formData.name" class="form-input br-5" type="text" name="name" id="input-name" placeholder="">
          </label>
        </div>
        <div class="form-padding">
          <label for="input-furigana">
            ふりがな
            <input v-model="formData.furigana" class="form-input br-5" type="text" name="furigana" id="input-furigana" placeholder="">
          </label>
        </div>
        <div class="form-padding">
          <label for="input-phone">
            電話番号
            <input v-model="formData.phone" class="form-input br-5" type="tel" name="phone" id="input-phone" placeholder="" data-com.agilebits.onepassword.user-edited="yes" :readonly="isReadonly">
          </label>
        </div>
        <div class="form-padding">
          <label for="preferred-branch">
            優先拠点
            <i class="preferred-help-icon zmdi zmdi-help zmdi-hc-1x tooltip" data-tooltip="拠点を選択する際、優先拠点は常にリスト上部に表示されます。"></i>
          </label>
          <select v-model="formData.preferredBranch" class="form-select br-5" name="preferred-branch">
            <option value="none">無し</option>
            <option v-for="branch in thisUser.employsCompanies" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
          </select>
        </div>

        <div class="form-padding user-form-footer">
          <button :class="loadingClass" class="oplus-modal-btn oplus-confirm-btn">変更</button>
        </div>
      </form>
    </div>

    <!-- SmartHR Attendance Token -->
    <div v-if="enabledSmartHR" class="user-details">
      <div class="form-padding smartHR-token">
        <label class="oplus-form-text">
          SmartHR勤怠 APIトークン
          <span data-tooltip="SmartHR勤怠に連携するためには、SmartHR勤怠側でAPIトークンを生成し、こちらに登録する必要がございます。" class="circle-question tooltip"></span>
        </label>
        <div class="input-group flex-end">
          <input v-if="!hasSmartHRAttendenceToken" class="form-input text-ellipsis br-5 disabled-input" value="APIトークンが設定されていません。" disabled></input>
          <input v-else class="form-input text-ellipsis br-5 disabled-input" value="APIトークンが設定されています。" disabled></input>
        </div>
        <div class="email-form-footer">
          <button id="email-modal-btn" class="oplus-modal-btn oplus-confirm-btn font-sm ml-1 br-5" type="button" @click="openSmartHRAttendanceTokenModal">
            編集
          </button>
        </div>
      </div>
    </div>

    <div class="user-details">
      <!-- Email Form -->
      <div class="form-padding">
        <label class="oplus-form-text" for="change-email">メールアドレス</label>
        <div class="input-group edit-email-form">
          <input v-if="isEmailEmpty" class="form-input text-ellipsis br-5" value="ログインメールなし" disabled></input>
          <input v-else class="form-input text-ellipsis br-5" :value="user.Email" disabled></input>
        </div>
        <div class="email-form-footer">
          <button id="email-modal-btn" class="oplus-modal-btn oplus-confirm-btn email-form-btn" type="button" @click="handleOpenEmailModal">
            メールの変更
          </button>
        </div>
      </div>
    </div>

    <div class="user-details">
      <!-- Password Form -->
      <div class="form-padding">
        <label class="oplus-form-text" for="password">パスワード</label>
        <div class="input-group edit-password-form">
          <div class="form-input text-ellipsis br-5">
            <label v-if="thisUser.isUserHasPassword" class="oplus-gray-text" for="password">パスワードは既に設定されています。</label>
            <label v-else class="oplus-gray-text" for="password">パスワードが設定されていません。</label>
          </div>
        </div>
        <div class="email-form-footer">
          <button id="password-modal-btn" class="oplus-modal-btn oplus-confirm-btn email-form-btn" type="button" @click="handleOpenPasswordModal">
            <div v-if="thisUser.isUserHasPassword">パスワードの変更</div>
            <div v-else>パスワード作成</div>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<style>
.user-form-container {
  padding-bottom: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.user-new-form-id {
  pointer-events: none;
}

.email-form-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.edit-email-form,
.edit-password-form {
  justify-content: flex-end;
}

.email-form-btn {
  width: fit-content;
}

.form-padding {
  padding: 0.5rem 1rem;
}

.form-padding + .form-padding {
  margin-top: 10px;
}

.oplus-form-checkbox + .oplus-form-checkbox {
  margin-top: 5px;
}

.br-5.br-5.br-5.br-5 {
  border-radius: 5px;
}

.preferred-help-icon.tooltip::after {
  white-space: normal;
  width: 200px;
}

.smartHR-token .tooltip::after {
  white-space: normal;
  height: auto;
  width: 320px;
  padding: 0.4rem;
}
</style>
